module.exports = "<div class=\"form-component\">\r\n  <div [innerHTML]=\"controlContext.text | safeHtml\"></div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/text-editors/paragraph-designer-component.html
// module id = ../../../../../src/app/private/sxfdesigner/components/designers/layout/text-editors/paragraph-designer-component.html
// module chunks = main